<template>
	<div class="main bg-white index">
		<div class="bls">
			<div class="bl1">
				<div class="buts">
					<el-button class="but" size="small" @click="on.edit({fid:0})" type="primary">新增分组</el-button>
				</div>
			</div>
			<div class="bl2">
				<div class="tab" ref="tab">
					<el-table class="eltab" :data="tab.data" row-key="id" border :height="heights">

						<el-table-column prop="name" label="名称"></el-table-column>

						<el-table-column label="是否推荐">
							<template slot-scope="scope">
								<span v-if="scope.row.istop">推荐</span>
							</template>
						</el-table-column>

						<el-table-column prop="sort" label="排序">
							<template slot-scope="scope">
								<el-input min="0" v-model="scope.row.sort" @blur="on.upsort(scope.row)" size="mini"
									class="tab_inp" type="number" placeholder="请输入内容">
								</el-input>
							</template>
						</el-table-column>

						<el-table-column label="操作" width="245">
							<template slot-scope="scope">
								<el-button size="mini" type="primary" @click="on.edit({fid:scope.row.id})"
									v-if="scope.row.fid == 0">添加病种</el-button>
								<el-button size="mini" type="primary" @click="on.sel_doctor(scope.row)" v-else>选择医生
								</el-button>
								<el-button size="mini" type="primary" @click="on.edit(scope.row)">编辑</el-button>
								<el-button size="mini" type="danger" @click="on.del(scope.row)">删除</el-button>
							</template>
						</el-table-column>

					</el-table>
				</div>
			</div>
		</div>
		<edit ref="edit"></edit>
		<doctor ref="doctor"></doctor>
	</div>
</template>

<script>
	import edit from './edit.vue';
	import doctor from './sel_doctor.vue';

	export default {
		components: {
			edit,
			doctor,
		},
		data() {
			var vue = this;

			return {
				tab: {
					data: [],
					order: ''
				},
				heights:null,
				on: {
					async up() {
						var [code, data] = await vue.ajax2('set/DiseaseType/getlist')
						switch (code) {
							case 0:
								var lis = [];
								for (var v of data) {
									if (v.fid == 0) {
										v.children = [];
										for (var v2 of data) {
											if (v2.fid == v.id)
												v.children.push(v2);
										}
										lis.push(v)
									}
								}
								vue.$set(vue.tab, 'data', lis)
								break;
						}

					},
					async edit(d) {
						vue.$refs.edit.init(d, async function (res) {
							var _res = xaoi.object_clone(res);
							_res.istop = _res.istop ? 1 : 0;
							var [code, data] = await vue.ajax2('set/DiseaseType/edit', _res);
							switch (code) {
								case 0:
									vue.$message({
										message: d.id ? '编辑成功' : '添加成功',
										type: 'success'
									});
									vue.on.up();
									return true;
									break;
								case -1:
									vue.$message({
										message: d.id ? '编辑失败' : '添加失败',
										type: 'error'
									});
									return true;
									break;
								case -2:
									this.err('name', '名称已使用')
									break;
							}
						})
					},
					async upsort(d) {
						var [code, data] = await vue.ajax2('set/DiseaseType/edit', d);
					},
					sel_doctor(d) {
						vue.$refs.doctor.init(d);
					},
					async del(d) {
						if (await new Promise(ok => {
								vue.$confirm('确认删除?', d.fid ? '删除病种' : '删除分组', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(ok, function () {})
							})) {
							var [code, data] = await vue.ajax2('set/DiseaseType/del', {
								id: d.id,
								fid: d.fid
							});
							switch (code) {
								case 0:
									vue.$message({
										message: '删除成功',
										type: 'success'
									});
									vue.on.up();
									break;
								case 1:
									vue.$message({
										message: '删除失败',
										type: 'error'
									});
									break;
							}
						}
					}
				}
			}
		},
		created() {
			var vue = this;

			vue.on.up();
		},
		mounted(){
			this.getHeight()
		},
		methods: {
			// 获取高度
			getHeight() {
				let that = this;
				that.heights = window.innerHeight - 250 + 'px'
				window.onresize = () => {
					that.heights = window.innerHeight - 250 + 'px'
				}
			},
		}
	}
</script>


<style lang="scss" scoped>
	.main {
		// margin: -1rem -20px -60px -20px;
		// height: calc(100% + 25px);
		border: none;

		.bls {
			height: 100%;
			display: flex;
			flex-flow: column;

			.bl1 {
				padding: 14px 16px;
			}

			.bl2 {
				flex: 1;
				height: 0;
				padding: 0 16px 14px;

				.tab {
					// height: 100%;

					.eltab {
						// border: 1px solid #f5f5f5;
						border-bottom: 0;
						// height: 100%;
						display: flex;
						flex-flow: column;
					}

					.el-table__body-wrapper {
						overflow-y: auto;
						overflow-x: hidden;
						flex: 1;
						height: 0;
					}
				}
			}
		}
	}
</style>